import { useState, useCallback } from 'react';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type {
	MediaUploadPermissionResponse,
	UploadContext,
	UseUploadPermissions,
	UploadCollectionType,
} from './types.tsx';
import { getMediaUploadPermissionUrl, getAttachmentsFieldCollectionUrl } from './utils.tsx';

export const useUploadPermissions: UseUploadPermissions = () => {
	const [isUploadPermissionFetching, setIsUploadPermissionFetching] = useState<boolean>(false);
	const [uploadPermissions, setUploadPermissions] = useState<UploadContext | null>(null);

	const fetchUploadPermissions = useCallback(
		async (projectId: string, uploadCollectionType?: UploadCollectionType): Promise<void> => {
			setIsUploadPermissionFetching(true);
			const permissionUrl =
				uploadCollectionType === 'project-collection'
					? getAttachmentsFieldCollectionUrl(projectId)
					: getMediaUploadPermissionUrl(projectId);

			try {
				const uploadResponse: MediaUploadPermissionResponse =
					await performGetRequest(permissionUrl);
				setUploadPermissions({
					clientId: uploadResponse.clientId,
					serviceHost: uploadResponse.endpointUrl,
					token: uploadResponse.token,
					tokenLifespanInMs: uploadResponse.tokenDurationInMins * 60 * 1000,
					collection: uploadResponse.targetCollection,
					tokenIssueTimestamp: Date.now() - 10000,
				});
				setIsUploadPermissionFetching(false);
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (err: any) {
				setIsUploadPermissionFetching(false);
				throw new Error(err);
			}
		},
		[],
	);
	return [isUploadPermissionFetching, uploadPermissions, fetchUploadPermissions];
};
